import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setIsAuthenticated(!!data.CP_Emailaddress);
        setLoading(false);
        //console.log(data);
      })
      .catch(() => {
        setIsAuthenticated(false);
        setLoading(false);
        //console.log("here");
      });
  }, []);

  if (loading) return <p>Loading...</p>;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
